export default "__VITE_ASSET__Ds0TYgNS__"